import { Mask } from "antd-mobile"
import { forwardRef, useImperativeHandle, useState } from "react"
import { useTranslation } from "react-i18next"
import CommonUtil from "../../utils/CommonUtil"

const ContactDialog = (props, ref) => {
    const { onPhoneClick, onWechatClick } = props
    const { t } = useTranslation()
    const [concatDlgVisible, setConcatDlgVisible] = useState(false)

    useImperativeHandle(ref, () => ({
        show: () => {
            setConcatDlgVisible(true)
        },
        dismiss: () => {
            setConcatDlgVisible(false)
        }
    }))

    return <>
        <Mask visible={concatDlgVisible} onMaskClick={() => setConcatDlgVisible(false)}
            color='#00000066'>
            <div className='cancatContent'>
                <div style={styles.dlgTitle}>
                    <span style={{ fontSize: 15, color: '#000000', fontWeight: '500' }}>{t('cancat')}</span>
                    <div style={{ position: 'absolute', top: 19, right: 15, width: 32, height: 32 }}
                        onClick={() => setConcatDlgVisible(false)}>
                        <img src={`${CommonUtil.getSourceDomain()}modal_close.png`} alt="" style={{ width: 32, height: 32 }} />
                    </div>
                </div>
                <span style={{ height: 6 }} />
                <div className='cancatContentItem' onClick={onPhoneClick}>
                    <img src={`${CommonUtil.getSourceDomain()}help_phone.png`} alt="" style={{ width: 40, height: 40, marginLeft: 20 }} />
                    <div style={{ display: 'flex', marginLeft: 15, flexDirection: 'column' }}>
                        <span style={{ color: '#917BBB', fontSize: 12, fontWeight: '500' }}>{t('cancat_phone')}</span>
                        <span style={{ color: '#000000', fontSize: 14, fontWeight: '500', marginTop: 5 }}>{t('phone_num')}</span>
                        <span style={{ color: '#00000080', fontSize: 12, marginTop: 2 }}>{t('work_time')}</span>
                    </div>
                </div>
                <span style={{ height: 14 }} />
                <div className='cancatContentItem' onClick={onWechatClick}>
                    <img src={`${CommonUtil.getSourceDomain()}help_wechat.png`} alt="" style={{ width: 40, height: 40, marginLeft: 20 }} />
                    <div style={{ display: 'flex', marginLeft: 15, flexDirection: 'column' }}>
                        <span style={{ color: '#917BBB', fontSize: 12, fontWeight: '500' }}>{t('wechat')}</span>
                        <span style={{ color: '#000000', fontSize: 14, fontWeight: '500', marginTop: 5 }}>{t('wechat_account')}</span>
                        <span style={{ color: '#00000080', fontSize: 12, marginTop: 2 }}>{t('work_time1')}</span>
                    </div>
                </div>
            </div>
        </Mask>
    </>
}

const styles = {
    itemText: {
        marginLeft: 15,
        color: '#000000CC',
        fontSize: 14,
        fontWeight: '500'
    },
    itemIcon: {
        width: 24,
        height: 24,
        marginRight: 15
    },
    cancat: {
        fontSize: 15,
        color: '#4C4C4CCC',
        fontWeight: '500'
    },
    dlgTitle: {
        display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%', height: 50, marginTop: 10
    }
}

export default forwardRef(ContactDialog)